export default __webpack_public_path__ + "static/media/kunle.59aa5243.png";